import React, { useEffect, useMemo, useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowUpRight, Package, Sparkles, Zap, Leaf, Heart, Coffee, Cloud, Gift, Scissors, Cog, Globe, Users, Wine, Server, ShoppingBag, Star, CircuitBoard, TreePine, BookOpen, UtensilsCrossed, Wifi, Palette, Anchor, Building2, MapPin, Monitor, Layout, Squirrel, Shield, Recycle, ExternalLink, GraduationCap, Plug, BarChart3, Newspaper, Store, ChevronLeft, ChevronRight } from 'lucide-react';
const ALL_FILTER = 'All';
const Icon3D = ({
  icon: Icon,
  colorClass,
  size = 24,
  isLarge = false
}: any) => {
  return <div style={{
    perspective: '800px'
  }} className="shrink-0" data-id="element-175">
      <motion.div animate={isLarge ? {
      y: [-5, 5, -5]
    } : {}} transition={isLarge ? {
      duration: 4,
      repeat: Infinity,
      ease: 'easeInOut'
    } : {}} style={{
      transform: 'rotateY(-15deg) rotateX(5deg)'
    }} className={`flex items-center justify-center rounded-xl bg-dark border border-white/5 shadow-lg ${isLarge ? 'w-24 h-24' : 'w-12 h-12'}`} data-id="element-176">
        <Icon size={size} className={colorClass} data-id="element-177" />
      </motion.div>
    </div>;
};
export function PortfolioSection() {
  const filterScrollRef = useRef<HTMLDivElement>(null);
  const [activeFilter, setActiveFilter] = useState(ALL_FILTER);
  const projects = [{
    id: 1,
    title: 'JYSK UK',
    category: 'Drupal / E-commerce',
    tags: ['Development', 'E-commerce'],
    website: 'https://jysk.co.uk/',
    color: 'bg-amber-900',
    icon: ShoppingBag,
    secondaryIcon: Package,
    tertiaryIcon: Store,
    accentColor: 'text-amber-500'
  }, {
    id: 2,
    title: 'Seacat by Rossinavi',
    category: 'React / Luxury Marine',
    tags: ['Development'],
    website: 'https://seacat.rossinavi.it/',
    color: 'bg-sky-900',
    icon: Anchor,
    secondaryIcon: Globe,
    tertiaryIcon: Sparkles,
    accentColor: 'text-sky-500'
  }, {
    id: 3,
    title: 'TransfrInc',
    category: 'Design / Corporate',
    tags: ['Design', 'Corporate'],
    website: 'https://transfrinc.com/',
    color: 'bg-slate-800',
    icon: Palette,
    secondaryIcon: Layout,
    tertiaryIcon: Monitor,
    accentColor: 'text-slate-400'
  }, {
    id: 6,
    title: 'MyCPACoach',
    category: 'Design / Education',
    tags: ['Design'],
    website: 'https://mycpacoach.com/',
    color: 'bg-indigo-900',
    icon: GraduationCap,
    secondaryIcon: BookOpen,
    tertiaryIcon: Star,
    accentColor: 'text-indigo-400'
  }, {
    id: 8,
    title: 'BENS',
    category: 'Custom Plugin / Non-Profit',
    tags: ['Development', 'Non-Profit'],
    website: 'https://bens.org/',
    color: 'bg-emerald-900',
    icon: Heart,
    secondaryIcon: Plug,
    tertiaryIcon: Users,
    accentColor: 'text-emerald-500'
  }, {
    id: 9,
    title: 'SABCap',
    category: 'Corporate / Finance',
    tags: ['Corporate'],
    website: 'https://sabcap.com',
    color: 'bg-zinc-800',
    icon: Building2,
    secondaryIcon: BarChart3,
    tertiaryIcon: Globe,
    accentColor: 'text-zinc-400'
  }, {
    id: 10,
    title: 'MyCalgary',
    category: 'Community / Portal',
    tags: ['Portal', 'Development'],
    website: 'https://mycalgary.com',
    color: 'bg-blue-900',
    icon: MapPin,
    secondaryIcon: Globe,
    tertiaryIcon: Users,
    accentColor: 'text-blue-500'
  }, {
    id: 13,
    title: 'The Human Squirrel',
    category: 'Creative / Web Design',
    tags: ['Design'],
    website: 'https://thehumansquirrel.com/',
    color: 'bg-amber-800',
    icon: Squirrel,
    secondaryIcon: Coffee,
    tertiaryIcon: Palette,
    accentColor: 'text-amber-500'
  }, {
    id: 14,
    title: 'WDCACDST',
    category: 'Non-Profit / Organization',
    tags: ['Non-Profit', 'Development'],
    website: 'https://wdcacdst.org/',
    color: 'bg-cyan-900',
    icon: Users,
    secondaryIcon: Globe,
    tertiaryIcon: BookOpen,
    accentColor: 'text-cyan-500'
  }, {
    id: 15,
    title: 'EcoMinim',
    category: 'E-commerce / Sustainable',
    tags: ['E-commerce', 'Design'],
    website: 'https://ecominim.com/',
    color: 'bg-green-900',
    icon: Leaf,
    secondaryIcon: Recycle,
    tertiaryIcon: TreePine,
    accentColor: 'text-green-500'
  }, {
    id: 16,
    title: 'Little Brand Box',
    category: 'E-commerce / Subscription Retail',
    tags: ['E-commerce'],
    website: 'https://littlebrandbox.com',
    color: 'bg-amber-900',
    icon: Package,
    secondaryIcon: Gift,
    tertiaryIcon: ShoppingBag,
    accentColor: 'text-amber-500'
  }, {
    id: 17,
    title: 'Hair Health',
    category: 'E-commerce / Health & Beauty',
    tags: ['E-commerce', 'Design'],
    website: 'https://hairhealth.co.za',
    color: 'bg-rose-900',
    icon: Sparkles,
    secondaryIcon: Scissors,
    tertiaryIcon: Star,
    accentColor: 'text-rose-400'
  }, {
    id: 18,
    title: 'Africa Switchgear',
    category: 'Industrial / Manufacturing',
    tags: ['Corporate', 'Development'],
    website: 'https://africaswitchgear.co.za',
    color: 'bg-slate-800',
    icon: Zap,
    secondaryIcon: Cog,
    tertiaryIcon: CircuitBoard,
    accentColor: 'text-yellow-500'
  }, {
    id: 19,
    title: 'TerraHub Marketplace',
    category: 'E-commerce / Sustainable Marketplace',
    tags: ['E-commerce', 'Development'],
    website: 'https://terrahubmarketplace.co.za',
    color: 'bg-emerald-900',
    icon: Leaf,
    secondaryIcon: Globe,
    tertiaryIcon: TreePine,
    accentColor: 'text-emerald-500'
  }, {
    id: 20,
    title: 'Global Parenting Initiative',
    category: 'Non-Profit / Education',
    tags: ['Non-Profit', 'Design'],
    website: 'https://globalparenting.org',
    color: 'bg-blue-900',
    icon: Heart,
    secondaryIcon: Users,
    tertiaryIcon: BookOpen,
    accentColor: 'text-blue-500'
  }, {
    id: 22,
    title: 'Cloudit',
    category: 'Technology / IT Services',
    tags: ['Corporate', 'Development'],
    website: 'https://cloudit.co',
    color: 'bg-purple-900',
    icon: Cloud,
    secondaryIcon: Server,
    tertiaryIcon: Wifi,
    accentColor: 'text-purple-400'
  }, {
    id: 23,
    title: 'Maiden Cricket',
    category: 'Shopify / E-commerce',
    tags: ['Shopify', 'E-commerce'],
    website: 'https://maiden-cricket.co.uk/',
    color: 'bg-green-900',
    icon: ShoppingBag,
    secondaryIcon: Store,
    tertiaryIcon: Star,
    accentColor: 'text-green-500'
  }, {
    id: 24,
    title: "Kelly's",
    category: 'E-commerce / Retail',
    tags: ['E-commerce', 'Development'],
    website: 'https://www.kellys.co.za/',
    color: 'bg-red-900',
    icon: ShoppingBag,
    secondaryIcon: Package,
    tertiaryIcon: Star,
    accentColor: 'text-red-500'
  }];
  // Derive unique filter categories dynamically
  const filterCategories = useMemo(() => {
    const tagSet = new Set<string>();
    projects.forEach(p => p.tags.forEach(t => tagSet.add(t)));
    return [ALL_FILTER, ...Array.from(tagSet).sort()];
  }, []);
  const filteredProjects = useMemo(() => {
    if (activeFilter === ALL_FILTER) return projects;
    return projects.filter(p => p.tags.includes(activeFilter));
  }, [activeFilter, projects]);
  const [selectedProjectId, setSelectedProjectId] = useState<number | null>(null);
  // Update selected project when filter changes
  useEffect(() => {
    if (filteredProjects.length > 0) {
      if (!filteredProjects.find(p => p.id === selectedProjectId)) {
        setSelectedProjectId(filteredProjects[0].id);
      }
    } else {
      setSelectedProjectId(null);
    }
  }, [filteredProjects, selectedProjectId]);
  const selectedProject = useMemo(() => {
    return projects.find(p => p.id === selectedProjectId) || filteredProjects[0];
  }, [selectedProjectId, projects, filteredProjects]);
  return <section id="portfolio" className="py-24 bg-dark-lighter overflow-hidden" data-id="element-178">
      <div className="max-w-[1320px] mx-auto px-4 relative" data-id="element-179">
        {/* Header Section */}
        <div className="mb-12" data-id="element-180">
          <motion.span initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-gold font-inter font-bold tracking-wider text-sm uppercase mb-2 block" data-id="element-181">
            Projects
          </motion.span>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-5xl md:text-6xl font-bold text-white font-syne uppercase leading-tight" data-id="element-182">
            Latest
          </motion.h2>
        </div>

        {/* Split Panel Layout */}
        <div className="flex flex-col lg:flex-row bg-dark rounded-2xl border border-white/10 overflow-hidden min-h-[600px] shadow-2xl" data-id="element-183">
          {/* Left Panel - Project List */}
          <div className="w-full lg:w-[35%] border-b lg:border-b-0 lg:border-r border-white/10 flex flex-col bg-dark" data-id="element-184">
            {/* Filter Tabs with Navigation */}
            <div className="p-4 border-b border-white/10 flex items-center gap-2" data-id="element-185">
              <button onClick={() => {
              if (filterScrollRef.current) {
                filterScrollRef.current.scrollBy({
                  left: -120,
                  behavior: 'smooth'
                });
              }
            }} className="shrink-0 w-7 h-7 rounded-full border border-white/10 flex items-center justify-center text-white/50 hover:text-gold hover:border-gold transition-colors" aria-label="Scroll categories left" data-id="element-186">
                <ChevronLeft size={14} data-id="element-187" />
              </button>
              <div ref={filterScrollRef} className="flex-1 overflow-x-auto no-scrollbar flex items-center gap-2" data-id="element-188">
                {filterCategories.map(category => <button key={category} onClick={() => setActiveFilter(category)} className={`relative px-4 py-1.5 font-inter text-xs font-medium rounded-full transition-colors whitespace-nowrap ${activeFilter === category ? 'bg-gold text-true-white' : 'bg-white/5 text-white/60 hover:text-white hover:bg-white/10'}`} data-id="element-189">
                    {category}
                  </button>)}
              </div>
              <button onClick={() => {
              if (filterScrollRef.current) {
                filterScrollRef.current.scrollBy({
                  left: 120,
                  behavior: 'smooth'
                });
              }
            }} className="shrink-0 w-7 h-7 rounded-full border border-white/10 flex items-center justify-center text-white/50 hover:text-gold hover:border-gold transition-colors" aria-label="Scroll categories right" data-id="element-190">
                <ChevronRight size={14} data-id="element-191" />
              </button>
            </div>

            {/* List */}
            <div className="flex-1 overflow-y-auto max-h-[300px] lg:max-h-[600px] flex lg:flex-col custom-scrollbar" data-id="element-192">
              {filteredProjects.map(project => {
              const isActive = project.id === selectedProject?.id;
              return <button key={project.id} onClick={() => setSelectedProjectId(project.id)} className={`flex items-center gap-4 p-4 text-left transition-all duration-300 shrink-0 lg:shrink border-b lg:border-b-0 lg:border-l-4 border-white/5 lg:border-white/0 ${isActive ? 'lg:border-l-gold border-b-gold lg:border-b-white/5 bg-dark-lighter' : 'hover:bg-white/5'}`} data-id="element-193">
                    <Icon3D icon={project.icon} colorClass={project.accentColor} size={20} data-id="element-194" />
                    <div className="hidden sm:block" data-id="element-195">
                      <h4 className={`font-syne font-bold text-base ${isActive ? 'text-gold' : 'text-white'}`} data-id="element-196">
                        {project.title}
                      </h4>
                      <p className="text-white/40 font-inter text-xs mt-0.5 truncate max-w-[180px]" data-id="element-197">
                        {project.website.replace('https://', '').replace(/\/$/, '')}
                      </p>
                    </div>
                  </button>;
            })}
            </div>
          </div>

          {/* Right Panel - Detail View */}
          <div className="w-full lg:w-[65%] p-8 lg:p-12 relative flex flex-col bg-dark-lighter" data-id="element-198">
            <AnimatePresence mode="wait" data-id="element-199">
              {selectedProject ? <motion.div key={selectedProject.id} initial={{
              opacity: 0,
              x: 20
            }} animate={{
              opacity: 1,
              x: 0
            }} exit={{
              opacity: 0,
              x: -20
            }} transition={{
              duration: 0.3
            }} className="flex flex-col h-full" data-id="element-200">
                  <div className="flex items-start justify-between mb-8" data-id="element-201">
                    <Icon3D icon={selectedProject.icon} colorClass={selectedProject.accentColor} size={40} isLarge={true} data-id="element-202" />
                    <span className="bg-gold/10 text-gold px-4 py-1.5 rounded-full text-sm font-inter font-semibold border border-gold/20" data-id="element-203">
                      {selectedProject.category}
                    </span>
                  </div>

                  <h3 className="text-4xl md:text-5xl font-bold text-white font-syne mb-6" data-id="element-204">
                    {selectedProject.title}
                  </h3>

                  <div className="flex flex-wrap gap-2 mb-8" data-id="element-205">
                    {selectedProject.tags.map(tag => <span key={tag} className="bg-white/5 border border-white/10 text-white/60 px-3 py-1 rounded-full text-xs font-inter" data-id="element-206">
                        {tag}
                      </span>)}
                  </div>

                  <p className="text-white/60 font-inter text-lg leading-relaxed max-w-2xl mb-12" data-id="element-207">
                    A modern {selectedProject.category.toLowerCase()} project
                    built to deliver exceptional user experiences, robust
                    functionality, and measurable business results.
                  </p>

                  <div className="mt-auto pt-8 border-t border-white/10 flex items-center justify-between" data-id="element-208">
                    <a href={selectedProject.website} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-gold hover:text-white transition-colors font-inter font-semibold text-lg group" data-id="element-209">
                      Visit Website
                      <ArrowUpRight size={20} className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" data-id="element-210" />
                    </a>

                    {/* Navigation Controls */}
                    <div className="flex items-center gap-3" data-id="element-211">
                      <span className="text-white/40 font-inter text-sm" data-id="element-212">
                        {filteredProjects.findIndex(p => p.id === selectedProject.id) + 1}{' '}
                        / {filteredProjects.length}
                      </span>
                      <button onClick={() => {
                    const idx = filteredProjects.findIndex(p => p.id === selectedProject.id);
                    if (idx > 0) setSelectedProjectId(filteredProjects[idx - 1].id);
                  }} disabled={filteredProjects.findIndex(p => p.id === selectedProject.id) === 0} className="w-9 h-9 rounded-full border border-white/10 flex items-center justify-center text-white/60 hover:text-gold hover:border-gold transition-colors disabled:opacity-30 disabled:cursor-not-allowed" data-id="element-213">
                        <ChevronLeft size={18} data-id="element-214" />
                      </button>
                      <button onClick={() => {
                    const idx = filteredProjects.findIndex(p => p.id === selectedProject.id);
                    if (idx < filteredProjects.length - 1) setSelectedProjectId(filteredProjects[idx + 1].id);
                  }} disabled={filteredProjects.findIndex(p => p.id === selectedProject.id) === filteredProjects.length - 1} className="w-9 h-9 rounded-full border border-white/10 flex items-center justify-center text-white/60 hover:text-gold hover:border-gold transition-colors disabled:opacity-30 disabled:cursor-not-allowed" data-id="element-215">
                        <ChevronRight size={18} data-id="element-216" />
                      </button>
                    </div>
                  </div>
                </motion.div> : <div className="flex items-center justify-center h-full text-white/40 font-inter" data-id="element-217">
                  Select a project to view details
                </div>}
            </AnimatePresence>
          </div>
        </div>
      </div>
    </section>;
}